import xhttp from 'src/utils/xhttp'

/**
 * 获取 引擎列表
 * @returns {Promise<AxiosResponse.data>}
 */
export function getLiteList() {
    return xhttp.get('/api/dev/app/engine/list')
}

/**
 * 获取 大于等于 某个特性版本的引擎列表
 * @param featureVersion
 * @returns {Promise<AxiosResponse.data>}
 */
export function getFeatureList(featureVersion) {
    return xhttp.get(`/api/dev/app/engine/feature-list/${featureVersion}`)
}
